module.exports = __webpack_public_path__ + "static/media/Hero.e93d8a0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/Hero.jpg
// module id = 3741
// module chunks = 0